<!-- <div mdbModal #videoModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
      aria-labelledby="myAdditionalUpdatesLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
  
  
          <div class="modal-content">
  
              <div class="video_close">
                  <span (click)="videoModal.hide()"><i class="fa-regular fa-circle-xmark"></i></span>
              </div>
              <div class="modal-body">
  
                  <div>
                      <plyr plyrTitle="Video 1" [plyrPlaysInline]="true" [plyrSources]="youtubeSources"
                          (plyrInit)="players = $event">
                        </plyr>
                  </div>  
              </div>
          </div>
      </div>
  </div> -->
  


<div mdbModal #videoModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
aria-labelledby="myAdditionalUpdatesLabel" aria-hidden="true">
<div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
<div class="modal-content">
 <div class="video_close">
   <span (click)="videoModal.hide()"><i class="fa-regular fa-circle-xmark"></i></span>
 </div>
 <div class="modal-body">
   <div>
     <plyr plyrTitle="Video 1" [plyrPlaysInline]="true" [plyrSources]="youtubeSources"
           (plyrInit)="players = $event">
     </plyr>
   </div>
 </div>
</div>
</div>
</div>

